import * as React from 'react';
import { useSelector } from 'react-redux';

import { ChatModalContainer } from '../../../common/containers/ChatModalContainer/ChatModalContainer';
import { selectIsOpen } from '../../../common/selectors/searchResults';
import { Sidebar } from '../../components/Sidebar';
import { SearchResultsContainer } from '../SearchResultsContainer';
import { SidebarHeaderContainer } from '../SidebarHeaderContainer';

export const SidebarContainer: React.FC = () => {
  const isOpen = useSelector(selectIsOpen);

  return (
    <>
      <Sidebar opened={isOpen}>
        <SidebarHeaderContainer />
        <SearchResultsContainer />
      </Sidebar>
      <ChatModalContainer />
    </>
  );
};

SidebarContainer.displayName = 'SidebarContainer';
